import { render, staticRenderFns } from "./r-item-boost-mode.vue?vue&type=template&id=18d07fdf"
import script from "./r-item-boost-mode.vue?vue&type=script&lang=js"
export * from "./r-item-boost-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d07fdf')) {
      api.createRecord('18d07fdf', component.options)
    } else {
      api.reload('18d07fdf', component.options)
    }
    module.hot.accept("./r-item-boost-mode.vue?vue&type=template&id=18d07fdf", function () {
      api.rerender('18d07fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/boost/r-item-boost-mode.vue"
export default component.exports